/**
 * "Sign out" from deep inside a screen — the work order or invoice a link
 * opened that this login can't see. Signing out keeps the link: the sign-in
 * page that follows says what it opens, and signing in with the right login
 * lands on it.
 */
import React, { createContext, useContext } from 'react';

type SignOut = () => void | Promise<void>;

const SignOutContext = createContext<SignOut | null>(null);

export const SignOutProvider: React.FC<{ signOut: SignOut; children: React.ReactNode }> = ({ signOut, children }) => (
  <SignOutContext.Provider value={signOut}>{children}</SignOutContext.Provider>
);

/** Null outside the signed-in app (then no Sign out button is offered). */
export const useSignOut = (): SignOut | null => useContext(SignOutContext);
